module.exports = __webpack_public_path__ + "img/kitchen.bffe63b.svg";